import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import Grid from '@material-ui/core/Grid';
import TableCell from '@material-ui/core/TableCell';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles, createStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import TableSortLabel from './TableSortLabel';
import responsive from './responsive';
import Icon from '../../../../core/Icon';

var styles = function styles(theme) {
  return createStyles({
    root: {},
    alignRight: {
      backgroundColor: '#eee'
    },
    textAlignment: {
      position: 'relative',
      top: -theme.spacing(1) / 2
    }
  });
};
/** @extends {React.Component<import('./types').DataGridViewDetailHeaderCellProps & import('@material-ui/core').WithStyles<typeof styles>> } */


var HeaderCell =
/*#__PURE__*/
function (_React$Component) {
  _inherits(HeaderCell, _React$Component);

  function HeaderCell() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, HeaderCell);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(HeaderCell)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      filterOpened: false
    };

    _this.onChangeSort = function (e) {
      if (_this.props.onChangeSort) _this.props.onChangeSort(e, _this.props.column.id);
    };

    _this.startFilter = function () {
      _this.setState({
        filterOpened: true
      });
    };

    _this.closeFilter = function () {
      _this.setState({
        filterOpened: false
      }, function () {
        if (_this.props.onChangeFilter) _this.props.onChangeFilter({}, '', _this.props.column.id);
      });
    };

    _this.onChangeFilter = function (e) {
      _this.props.onChangeFilter(e, e.target.value, _this.props.column.id);
    };

    return _this;
  }

  _createClass(HeaderCell, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          column = _this$props.column,
          filter = _this$props.filter,
          sort = _this$props.sort,
          by = _this$props.by,
          classes = _this$props.classes,
          width = _this$props.width;
      var cellProps = {
        classes: {
          alignRight: classes.alignRight
        },
        style: _objectSpread({}, column.style),
        align: column.align ? column.align : column.numeric ? 'right' : 'inherit'
      };
      if (column.filterable) cellProps.style.marginRight = -24;
      var columnWidth = responsive.getColumnWidth(column, width);
      if (columnWidth === 0) return null; //collapse column

      if (columnWidth && columnWidth !== 'auto') cellProps.style.width = columnWidth;
      var children = responsive.getColumnChildren(column, width);
      return React.createElement(TableCell, Object.assign({
        className: classes.root,
        key: column.id,
        sortDirection: column.id === by && sort
      }, cellProps), this.state.filterOpened ? React.createElement(TextField, {
        autoFocus: true,
        fullWidth: true,
        value: filter,
        placeholder: column.label || column.id,
        onChange: this.onChangeFilter,
        InputProps: {
          endAdornment: React.createElement(InputAdornment, {
            position: "end"
          }, React.createElement(Icon, {
            hoverable: true,
            buttonSize: "small",
            type: "close",
            onClick: this.closeFilter
          }))
        }
      }) : React.createElement(Grid, {
        container: true,
        alignItems: "center"
      }, React.createElement(Grid, {
        item: true,
        xs: true
      }, column.sortable ? React.createElement(Tooltip, {
        title: 'Sort ' + (sort === 'asc' ? ' descending ' : ' ascending ') + (typeof children === 'string' ? ' by ' + children : ''),
        placement: column.numeric || column.align === 'right' ? 'top-end' : 'top-start',
        enterDelay: 200
      }, React.createElement(TableSortLabel, {
        active: column.id === by && !!this.props.onChangeSort,
        direction: sort,
        onClick: this.onChangeSort,
        className: classes.textAlignment
      }, children)) : children), React.createElement(Grid, {
        item: true
      }, column.filterable && React.createElement(Icon, {
        hoverable: true,
        type: "search",
        onClick: this.startFilter
      })), column.moreChildren && React.createElement(React.Fragment, null, React.createElement(Grid, {
        item: true,
        xs: true
      }), React.createElement(Grid, {
        item: true
      }, React.createElement(Icon, {
        type: "more",
        label: "Options",
        style: {
          fontSize: '1rem',
          opacity: 0.6
        },
        onClick: function onClick() {
          return column.moreChildren(column);
        }
      })))));
    }
  }]);

  return HeaderCell;
}(React.Component);

export default withStyles(styles, {
  name: 'ECHeaderCell'
})(withWidth()(HeaderCell));